const ThreeDots = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    {...props}
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx="9.2" cy="3.7" r="1.7" fill="#535862" />
    <circle cx="9.2" cy="8.9998" r="1.7" fill="#535862" />
    <circle cx="9.2" cy="14.2996" r="1.7" fill="#535862" />
  </svg>
);

export default ThreeDots;
